import { render, staticRenderFns } from "./_consent-collection.vue?vue&type=template&id=6d820c04&scoped=true"
import script from "./_consent-collection.vue?vue&type=script&lang=js"
export * from "./_consent-collection.vue?vue&type=script&lang=js"
import style0 from "./_consent-collection.vue?vue&type=style&index=0&id=6d820c04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d820c04",
  null
  
)

export default component.exports